import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import Icon from '@mdi/react';
import {
  mdiDelete,
  mdiPencil,
  mdiCircle,
  mdiRotateLeft,
  mdiClipboardOutline,
} from '@mdi/js';
import BlockUi from 'react-block-ui';
import Button from '../../components/Button';
import {
  comprehensionSelector,
  dateSelector,
  superBillSelector,
  textSelector,
  titleSelector,
} from './reducer';
import { deleteNote, DELETE_NOTE_REQUEST } from '../NoteEditPage/actions';
import { createLoadingSelector } from '../Main/reducer';
import { FormattedMessage } from 'react-intl';
import { Helmet } from 'react-helmet';
import NoteBox from './components/NoteBox';
import ConfirmModal from '../NotesPage/components/ConfirmModal';

class NotePage extends React.Component {
  state = {
    showComprehensionModal: false,
    showSuperBillModal: false,
    showDeleteModal: false,
  };

  render() {
    const {
      theme,
      history,
      deleteNote,
      match,
      text,
      title,
      comprehension,
      superBill,
      loading,
      date,
      role,
    } = this.props;
    return (
      <BlockUi
        tag="div"
        blocking={loading}
        className="flex-fill d-flex flex-column"
      >
        <Helmet>
          <title>{title} | VoiceboxMD Web</title>
        </Helmet>
        <React.Fragment>
          <style>
            {`
              .custom-modal-backdrop {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.5);
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 1rem;
                z-index: 1050;
                overflow: auto;
              }

              .custom-modal-content {
                background: #fff;
                padding: 1.5rem;
                border-radius: 8px;
                max-width: 600px;
                width: 100%;
                max-height: 80vh;
                overflow-y: auto;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
              }

              @media (max-width: 480px) {
                .custom-modal-content {
                  padding: 1rem;
                  max-width: 100%;
                }
              }
            `}
          </style>

          <div className="d-flex">
            <Button
              onClick={() => this.setState({ showDeleteModal: true })}
              noPadding
              className="mr-3"
            >
              <Icon
                path={mdiDelete}
                size={1}
                color={theme.color.default}
                style={{ marginTop: '-4px' }}
              />
              <div className="ml-1">
                <FormattedMessage id="NotesPage.deleteNote" />
              </div>
            </Button>
            <CopyToClipboard
              text={text}
              onCopy={() => toast.info(`Note ${title} copied!`)}
            >
              <Button style={{ marginLeft: -24 }}>
                <Icon
                  path={mdiClipboardOutline}
                  size={1}
                  color={theme.color.default}
                  style={{ marginTop: -4, marginRight: 4 }}
                />
                <FormattedMessage id="NotePage.copyNote" />
              </Button>
            </CopyToClipboard>
            <Button
              onClick={history.goBack}
              className="ml-auto"
              style={{ marginRight: -12 }}
            >
              <Icon
                path={mdiRotateLeft}
                size={1}
                color={theme.color.default}
                style={{ marginTop: -4, marginRight: 4 }}
              />
              <FormattedMessage id="NotePage.goBack" />
            </Button>
            <Button
              onClick={() => history.push('/edit/' + match.params.id)}
              noPadding
            >
              <Icon
                path={mdiPencil}
                size={1}
                color={theme.color.default}
                style={{ marginTop: '-4px' }}
              />
              <div className="ml-1">
                <FormattedMessage id="NotePage.editNote" />
              </div>
            </Button>
          </div>
          <ConfirmModal
            isOpen={this.state.showDeleteModal}
            toggle={() => this.setState({ showDeleteModal: false })}
            onConfirm={() => {
              deleteNote(match.params.id);
              this.setState({ showDeleteModal: false });
            }}
            message="Are you sure you want to delete this note?"
          />
          <NoteBox
            style={{
              padding: '1rem',
              backgroundColor: '#fff',
              borderRadius: '8px',
              boxShadow: '0 0 10px rgba(0, 0, 0, 0.05)',
            }}
          >
            {role === 'pro' && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: '12px',
                  marginBottom: '1rem',
                  '@media (max-width: 480px)': {
                    flexDirection: 'column',
                    alignItems: 'stretch',
                  },
                }}
              >
                {comprehension && (
                  <Button
                    onClick={() =>
                      this.setState({ showComprehensionModal: true })
                    }
                    style={{
                      backgroundColor: theme.color.secondary || '#007bff',
                      color: '#fff',
                      padding: '8px 16px',
                      borderRadius: '6px',
                      border: '1px solid transparent',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s, transform 0.1s',
                      ':hover': {
                        backgroundColor: '#0056b3',
                        transform: 'scale(1.02)',
                      },
                      ':active': {
                        transform: 'scale(0.98)',
                      },
                      '@media (max-width: 480px)': {
                        width: '100%',
                        textAlign: 'center',
                      },
                    }}
                  >
                    <FormattedMessage
                      id="NotePage.viewComprehension"
                      defaultMessage="View Comprehension"
                    />
                  </Button>
                )}
                {superBill && (
                  <Button
                    onClick={() => this.setState({ showSuperBillModal: true })}
                    style={{
                      backgroundColor: theme.color.secondary || '#28a745',
                      color: '#fff',
                      padding: '8px 16px',
                      borderRadius: '6px',
                      border: '1px solid transparent',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s, transform 0.1s',
                      ':hover': {
                        backgroundColor: '#218838',
                        transform: 'scale(1.02)',
                      },
                      ':active': {
                        transform: 'scale(0.98)',
                      },
                      '@media (max-width: 480px)': {
                        width: '100%',
                        textAlign: 'center',
                      },
                    }}
                  >
                    <FormattedMessage
                      id="NotePage.viewSuperBill"
                      defaultMessage="View Super Bill"
                    />
                  </Button>
                )}
              </div>
            )}
            <div
              style={{
                color: '#6c757d',
                fontSize: '0.85rem',
                marginBottom: '0.5rem',
                textAlign: 'right',
              }}
            >
              Created on:{' '}
              {new Date(date).toLocaleString(undefined, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })}
            </div>

            <h3
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '1.25rem',
                marginBottom: '1rem',
              }}
            >
              <Icon path={mdiCircle} size={0.4} color={theme.color.dot} />
              <span style={{ marginLeft: '0.5rem', paddingLeft: '0.25rem' }}>
                {title}
              </span>
            </h3>

            <div dangerouslySetInnerHTML={{ __html: text }} />
          </NoteBox>
          {this.state.showComprehensionModal && (
            <div className="custom-modal-backdrop">
              <div className="custom-modal-content">
                <h5>Comprehension</h5>
                <div
                  style={{ whiteSpace: 'pre-wrap', marginBottom: '1rem' }}
                  dangerouslySetInnerHTML={{ __html: comprehension }}
                />
                <div className="d-flex justify-content-end">
                  <CopyToClipboard
                    text={comprehension}
                    onCopy={() => toast.info('Comprehension copied!')}
                  >
                    <Button className="mr-2">Copy</Button>
                  </CopyToClipboard>
                  <Button
                    onClick={() =>
                      this.setState({ showComprehensionModal: false })
                    }
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          )}

          {this.state.showSuperBillModal && (
            <div className="custom-modal-backdrop">
              <div className="custom-modal-content">
                <h5>Super Bill</h5>
                <div
                  style={{ whiteSpace: 'pre-wrap', marginBottom: '1rem' }}
                  dangerouslySetInnerHTML={{ __html: superBill }}
                />
                <div className="d-flex justify-content-end">
                  <CopyToClipboard
                    text={superBill}
                    onCopy={() => toast.info('Super Bill copied!')}
                  >
                    <Button className="mr-2">Copy</Button>
                  </CopyToClipboard>
                  <Button
                    onClick={() => this.setState({ showSuperBillModal: false })}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          )}
        </React.Fragment>
      </BlockUi>
    );
  }
}

NotePage = withTheme(NotePage);

NotePage = connect(
  createStructuredSelector({
    text: textSelector,
    title: titleSelector,
    date: dateSelector,
    comprehension: comprehensionSelector,
    superBill: superBillSelector,
    role: (state) => state.main.user.role,
    loading: createLoadingSelector([DELETE_NOTE_REQUEST]),
  }),
  { deleteNote }
)(NotePage);

export default NotePage;
